<template>
  <component :is="scene" ref="component_ref" :page-config="page_config" />
</template>

<script>
import { getPageConfig } from '@/views/auxiliary/title/config';

export default {
  components: {
    'UploadTitle': () => import('@/views/auxiliary/title/stages/upload/index.vue'),
    'ChooseTitle': () => import('@/views/auxiliary/title/stages/choose/index.vue'),
    'DefaultTitle': () => import('@/views/auxiliary/title/stages/default/index.vue'),
  },
  props: {
    /**
     * 页面场景值：可选UploadTitle、ChooseTitle、DefaultTitle
     * UploadTitle：提供批量上传标题的功能
     * ChooseTitle：提供选择标题的功能
     * DefaultTitle：拥有标题库所有功能，增删改查，批量增删
     */
    scene: {
      type: String,
      default: 'DefaultTitle',
    },

    /**
     * 传递给页面场景的props属性，用于获取场景页面的所属配置信息
     * 格式：{ permissions: '页面所属权限值' }
     */
    sceneProps: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      page_config: {},
    };
  },
  watch: {
    '$route': {
      handler(to) {
        const { permissions } = this.scene === 'DefaultTitle' ? to.meta : this.sceneProps || {};
        const page_config = getPageConfig(permissions);
        Object.assign(this.page_config, page_config);
      },
      immediate: true,
    },
  },
};
</script>
